/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import React from 'react';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import { Carousel } from 'react-bootstrap';
import Img1 from '../assets/img/ebmt/1.jpg';
import Img2 from '../assets/img/ebmt/2.jpg';
import Img3 from '../assets/img/ebmt/3.jpg';
import Img4 from '../assets/img/ebmt/4.jpg';
import Img5 from '../assets/img/ebmt/5.jpg';
import Img6 from '../assets/img/ebmt/6.jpg';
import Img7 from '../assets/img/ebmt/7.jpg';

function EbmtEvent() {
    return (
        <>
            <Header1 />
            <section className="portfolio-wrapper-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-12 text-center">
                            <div className="section-title-2">
                                <span>EMBT</span>
                                <h1>Cytocare activities</h1>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5 justify-content-md-center">
                        <div className='col-7'>
                            <Carousel fade>
                                
                                <Carousel.Item>
                                    <img
                                    className="d-block w-100"
                                    src={Img2}
                                    alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                    className="d-block w-100"
                                    src={Img3}
                                    alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                    className="d-block w-100"
                                    src={Img4}
                                    alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                    className="d-block w-100"
                                    src={Img5}
                                    alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                    className="d-block w-100"
                                    src={Img6}
                                    alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                    className="d-block w-100"
                                    src={Img7}
                                    alt="First slide"
                                    />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img
                                    className="d-block w-100"
                                    src={Img1}
                                    alt="First slide"
                                    />
                                </Carousel.Item>
                               
                            </Carousel>
                        </div>                
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default EbmtEvent;